import { Header, Table } from '@tanstack/react-table'
import {
    areSubHeadersPlaceholders,
    areSubHeadersPlaceholdersRecursive,
} from './areSubHeadersPlaceholders'
import { findParentHeader } from './findParentHeader'
import { getNestedLevels } from './getNestedLevels'
import { hasOnlyOrphanDescendants } from './hasOnlyOrphanDescendants'

/**
 * Calculates the rowspan for a given header based on its structure and relationship to other headers.
 */
export const calculateRowSpan = (
    currentHeader: Header<unknown, unknown>,
    table: Table<unknown>
): number => {
    const parentHeader = findParentHeader(currentHeader, table)

    if (
        parentHeader &&
        !parentHeader.isPlaceholder &&
        areSubHeadersPlaceholders(parentHeader)
    ) {
        return 1
    }

    if (
        (currentHeader.isPlaceholder &&
            currentHeader.subHeaders.length &&
            areSubHeadersPlaceholdersRecursive(currentHeader)) ||
        hasOnlyOrphanDescendants(currentHeader)
    ) {
        return getNestedLevels(currentHeader) // Total nested levels for rowspan
    }

    return 1
}
